import {
    getTelegramWebApp,
    isTelegramKVersion,
    isTelegramAVersion,
    isWebView,
} from '@24i/nxg-sdk-higgs/src/utils';
import { WithWebHeaderProps } from '../navigation/components/withWebHeader/types';

/**
 * Create consistent web header props for screens that need a title and back button
 * This utility helps keep header/title behavior consistent across screens and platforms
 *
 * @param title - The title to display in the header
 * @param backButtonTitle - Optional custom back button title (defaults to title)
 * @param fallbackTitle - Optional fallback if title is not available
 * @returns WithWebHeaderProps object to pass to withWebHeader HOC
 */
export function createWebHeaderProps(
    title: string | undefined,
    backButtonTitle?: string,
    fallbackTitle = 'Back'
): WithWebHeaderProps {
    // Check if we're in Telegram environment
    const isTelegram = !!getTelegramWebApp();
    const isTelegramK = isTelegramKVersion();
    const isTelegramA = isTelegramAVersion();

    // Use provided title or fallback
    const headerTitle = title || fallbackTitle;

    return {
        // Use the provided title for webHeaderTitle
        webHeaderTitle: headerTitle,
        // Use either explicit backButtonTitle, title, or fallback
        backButtonTitle: backButtonTitle || headerTitle,
        fullWidth: true,
        hasMargin: false,
        noVerticalMargin: true,
        isBackButtonHeaderText: true,
        // CRITICAL: Never disable for Telegram to ensure back button is handled by withWebHeader
        forceDisable: !isTelegram && !isWebView() && !isTelegramK && !isTelegramA,
        forceShowHeader: true,
    };
}
